export default __webpack_public_path__ + "static/Fallback-At-Home-Lab-Test-554d0da215cf232a014895f00acbdc5b.png";